// Set up your application entry point here...
/* eslint-disable import/default */

import React from "react";
import { render } from "react-dom";
import { AppContainer } from "react-hot-loader";
import configureStore, { history } from "./store/configureStore";
import Root from "./modules/Root";
import "../public/css/bootstrap.css";
import "./scss/main.scss";
import "./scss/admin/admin.scss";
import theme from "./theme/theme";
import { GlobalStyle } from "@plum-xoxo/admin-dsm";
import { ThemeProvider } from "styled-components";
import { BrowserRouter as Router } from "react-router-dom";
import { PostHogProvider } from "posthog-js/react";

const env = process.env.NODE_ENV || "production";
const config = require(`./config/config.${env}.json`);
const options = {
  api_host: config.posthog_api_host,
  persistence: "localStorage+cookie",
  SECURE_COOKIES: true,
};

// import './styles/styles.scss'; // Yep, that's right. You can import SASS/CSS files too! Webpack will run the associated loader and plug this into the page.
require("./favicon.ico"); // Tell webpack to load favicon.ico
const store = configureStore();

function createScriptElements() {
  const gtmKey = config.gtmKey;

  // add script el
  const headEl = document.getElementsByTagName("head")[0];
  const scriptTag = document.createElement("script");
  scriptTag.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','${gtmKey}');`;
  headEl.appendChild(scriptTag);

  //add no script el
  const noScriptEl = document.createElement("noscript");
  noScriptEl.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmKey}"
  height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
  const appElement = document.getElementById("app");
  appElement.parentNode.insertBefore(noScriptEl, appElement.nextElementSibling);
}

createScriptElements();

render(
  <PostHogProvider apiKey={config.posthog_api_key} options={options}>
    <AppContainer>
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        <Root
          store={store.store}
          history={history}
          persistor={store.persistor}
        />
      </ThemeProvider>
    </AppContainer>
  </PostHogProvider>,
  document.getElementById("app")
);

if (module.hot) {
  module.hot.accept("./modules/Root", () => {
    const NewRoot = require("./modules/Root").default;
    render(
      <PostHogProvider apiKey={config.posthog_api_key} options={options}>
        <Router>
          <AppContainer>
            <ThemeProvider theme={theme}>
              <GlobalStyle />
              <Root
                store={store.store}
                history={history}
                persistor={store.persistor}
              />
            </ThemeProvider>
          </AppContainer>
        </Router>
      </PostHogProvider>,
      document.getElementById("app")
    );
  });
}
